<template>
  <div class="presentation" v-else>
    <vpreloader v-if="loading"/>
    <div class="error" v-else-if="error">
      <span class="error-text">{{ $tr('responses.presentation.error') + error }}</span>
      <vbutton
        class="button"
        label="responses.tags.distributionRules.refresh"
        @click="load"/>
    </div>
    <div v-else-if="presentation_link">
      <object
        class="pdf"
        type="application/pdf"
        :data="presentation_link">
        {{ $tr('responses.presentation.notSupport') }} <a :href="presentation_link">{{ $tr('responses.presentation.download') }}</a>
      </object>
    </div>
  </div>
</template>
<script>

  import axios from 'axios';
  import {handleError} from '@/_helpers/utils.js'

  export default {
    name: 'response-tab-presentation-jti-make-it-bright',
    data () {
      return {
        presentation_link: null,
        loading: false,
        error: null
      }
    },
    props: {
      response: Object
    },
    computed: {
      params () {
        return {
          request_id: this.response.id
        }
      }
    },
    methods: {
      load () {
        this.loading = true;
        this.not_found = false;
        this.error = null;
        axios.get(`/1.0/spec-private/jti/second-stage/presentation`, {params: this.params})
          .then(response => {
            this.presentation_link = response.data.presentation_link;
            this.error = response.data.error ? this.$tr('responses.presentation.notFound') : null;
          })
          .catch(error => {
            if (error.response.status === 404) {
              this.error = this.$tr('responses.presentation.notFound');
            } else {
              this.error = handleError(error);
            }
          })
          .then(() => {
            this.loading = false;
          })
      }
    },
    created () {
      this.load();
    }
  }
</script>
<style lang="scss" scoped>
  @import '../../../../../../../styles/colors';

  .presentation {
    padding: 10px 0;
    .pdf {
      width: 100%;
      height: calc(100vh - 215px);
    }
    .error {
      padding: 5px 0;

      .error-text {
        font-size: 14px;
        color: $red-color;
      }

      .button {
        margin-left: 5px;
      }
    }
  }
</style>